// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_rj-0";
export var checkoutRateBadgeLink = "_rj-1";